export function getBasePath(siteUrl = '') {
    try {
        const [, ...tail] = new URL(siteUrl).pathname.split('/');
        return `/${tail.filter(Boolean).join('/')}`;
    }
    catch (_) {
        return '';
    }
}
//# sourceMappingURL=getBasePath.js.map